// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import {
  bicRevampCategoryPage,
  bicRevampCategoryViewAllPage,
} from '../../../alias/homeRoutes';
import bicActionType from '../../../actions/bicAction/actionType';
import TilesContainer from '../tilesContainer';
import Category from '../category';
import type { CategoryType } from '../../../modelType/bicType';
import { tracker, UserActionType } from '../../../tracking';
import style from './style.css';
import CustomSlider from '../../common/customSlider';
import { useRef } from 'preact/hooks';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { connect } from 'react-redux';

type Props = {
  campaignId: string,
  header: string,
  pageKey: string,
  lenderId: string,
  data: Array<CategoryType>,
  bicAction: Function,
};

const CategorySlider = ({
  data,
  campaignId,
  header,
  lenderId,
  pageKey,
  bicAction,
}: Props) => {
  const customSliderRef = useRef(null);
  return (
    <div className={style.categoriesContainer}>
      <CustomSlider
        ref={customSliderRef}
        childWidth={105}
        noOfSlides={data.length}
        customSettings={{
          arrows: true,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                arrows: false,
              },
            },
          ],
        }}>
        {data
          .filter((category) => category.featured === true)
          .map((itm, index) => {
            return (
              <Category
                lenderId={lenderId}
                tile={itm}
                index={index}
                tileClickAction={() => {
                  tracker.trackUserInteraction(
                    UserActionType.CLICK,
                    'bic_category_tile',
                    pageKey,
                    {
                      tile_name: itm.name,
                      campaign_id: campaignId,
                      lender_id: lenderId,
                    },
                  );
                  return route(
                    itm.id === 'allCategoriesTile'
                      ? generateUrlWithParams(
                          bicRevampCategoryViewAllPage.path,
                          {
                            utm_campaign: campaignId,
                          },
                        )
                      : generateUrlWithParams(bicRevampCategoryPage.path, {
                          c: itm.id,
                          utm_campaign: campaignId,
                        }),
                  );
                }}
              />
            );
          })}
      </CustomSlider>
    </div>
  );
};

export default connect(
  null,
  {},
)(CategorySlider);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/categorySlider/index.js